



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserInfo, AuthorState } from '@/store/interface';
import { namespace } from 'vuex-class';
import { AuthorModule, authorAction, authorMutation } from '@/store/types';

const Module = namespace(AuthorModule);

@Component
export default class UserDetail extends Vue {
  @Module.State((state: AuthorState) => state.author)
  private userInfo!: UserInfo | null;
}
